import React from 'react'
import {FireFilled} from '@ant-design/icons'

const Logo = () => {
  return (
    <div className='logoo'>
        <div className="logoo-icon">
            <FireFilled/>
        </div>
    </div>
  )
}

export default Logo